import * as React from 'react';

function SvgRoleBd(props) {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#role-bd_svg__a)">
        <circle cx={16} cy={16} r={16} fill="#38B2A6" />
        <path
          d="M22.17 16.11H15.9V9.83a.14.14 0 00-.14-.14h-.46a7 7 0 00-4.97 11.99 6.99 6.99 0 007.66 1.52 7 7 0 004.33-6.49v-.46a.14.14 0 00-.14-.14zm1.55-.97l-.05-.5a6.98 6.98 0 00-6.33-6.31l-.5-.05a.14.14 0 00-.15.14v6.75c0 .07.07.14.14.14l6.75-.02c.08 0 .14-.07.14-.15z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="role-bd_svg__a">
          <path fill="#fff" d="M0 0h32v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgRoleBd;
